import React from 'react';
import FieldSelect from '../FieldSelect/FieldSelect';
import { getOptionLabel, getOptionValue } from '../../util/sizeHelpers';

const SizeSelector = ({
  id,
  name,
  label,
  placeholder,
  options = [],
  initialValue,
  validate,
  className,
  disabled = false,
}) => {
  return (
    <FieldSelect
      className={className}
      id={id}
      name={name}
      label={label}
      initialValue={initialValue}
      validate={validate}
      disabled={disabled}
    >
      <option disabled value="">
        {placeholder}
      </option>
      {options.map((option, index) => {
        const optionValue = getOptionValue(option);
        if (!optionValue) {
          return null;
        }

        return (
          <option key={`${optionValue}-${index}`} value={optionValue}>
            {getOptionLabel(option) || optionValue}
          </option>
        );
      })}
    </FieldSelect>
  );
};

export default SizeSelector;
